export const DEFAULT_STALE_TIME_IN_SECONDS = 2;
export const SLOW_DATA_STALE_TIME_IN_SECONDS = 30;
